
import state from './moduleAccountsManagementState'
import mutations from './moduleAccountsManagementMutations'
import actions from './moduleAccountsManagementActions'
import getters from './moduleAccountsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

